"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _distribution = require("@/api/distribution");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LeaderAudit',
  filters: {
    auditStatusFilter: function auditStatusFilter(status) {
      var map = {
        0: '待审核',
        1: '已审核',
        2: '已驳回'
      };
      return map[Number(status)] || '未知';
    }
  },
  data: function data() {
    return {
      timeVal: [],
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      tableFrom: {
        dateLimit: '',
        content: '',
        searchType: 'all',
        page: 1,
        limit: 20
      },
      dialogVisible: false,
      submitLoading: false,
      auditForm: {
        id: '',
        status: 1,
        remark: ''
      },
      auditRules: {
        status: [{
          required: true,
          message: '请选择审核结果',
          trigger: 'change'
        }],
        remark: [{
          required: true,
          message: '请输入驳回原因',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    // 重置
    handleReset: function handleReset() {
      this.tableFrom.dateLimit = '';
      this.tableFrom.content = '';
      this.tableFrom.searchType = 'all';
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
    },
    seachList: function seachList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    // 选择时间
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
    },
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _distribution.promoterApplyListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 打开审核弹窗
    onAudit: function onAudit(row) {
      var _this2 = this;
      this.auditForm = {
        id: row.id,
        status: 1,
        remark: ''
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs.auditForm && _this2.$refs.auditForm.clearValidate();
      });
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 提交审核
    submitAudit: function submitAudit() {
      var _this3 = this;
      this.$refs.auditForm.validate(function (valid) {
        if (!valid) return;
        _this3.submitLoading = true;
        var request = _this3.auditForm.status === 1 ? (0, _distribution.promoterApplyApproveApi)(_this3.auditForm.id) : (0, _distribution.promoterApplyRejectApi)(_this3.auditForm.id, {
          remark: _this3.auditForm.remark
        });
        request.then(function () {
          _this3.$message.success('审核成功');
          _this3.submitLoading = false;
          _this3.dialogVisible = false;
          _this3.getList();
        }).catch(function () {
          _this3.submitLoading = false;
        });
      });
    }
  }
};